module.exports = __webpack_public_path__ + "media/events.94832e3f.mp4";